import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locales'
import { utilV2 } from '@/serves/http'
import ApiPath from '@/serves/path'
import VConsole from 'vconsole'
import { isMobile } from '@/utils/browser'
// import * as Sentry from '@sentry/vue'
const env = process.env.NODE_ENV
// 加载全部svg图标
import '@/icons/index'

// 加载自定义插件
import CustomPlugin from '@/utils/install'
Vue.use(CustomPlugin)

// 加载自定义组件库1
import UiPlugin from '@/components/mui/index'
Vue.use(UiPlugin)

// 加载自定义组件库2
import baseUI from '@/components/ui'
Vue.use(baseUI)

// 引入element-ui
import './utils/element-ui-import'
// import ElementLocale from "element-ui/lib/locale";
// ElementLocale.i18n((key, value) => i18n.t(key, value));

// 引入material-ui
import './utils/material-ui-import'

// 加载全局样式
import '@/styles/index.scss'
// 引入vconsole
if (env !== 'production' && isMobile) {
  new VConsole()
}
// 引入sentry
// if (env !== 'development') {
//   Sentry.init({
//     Vue,
//     dsn: 'https://f90b6d3725d2c05da6440d3fab264d89@o4507056637607936.ingest.us.sentry.io/4507140743364608',
//     integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//     // Performance Monitoring
//     tracesSampleRate: 1.0, //  Capture 100% of the transactions
//     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//     // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//     environment: process.env.VUE_APP_SENTRY_ENV,
//     release: 'mock-test-web', // 版本号
//   })
// }
import generalQuestionType from '@/components/generalQuestionType'
Vue.use(generalQuestionType)

import hsk from '@/components/hsk'

Vue.use(hsk)

window.utilV2 = utilV2
window.ApiPath = ApiPath

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
